var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-search',{attrs:{"timeScreen":"","order":1,"searchParams":_vm.searchParams},on:{"searchEvent":_vm.searchEvent}}),_c('myTable',{attrs:{"loading":_vm.loading,"tableData":_vm.tableData,"tableHeader":_vm.tableHeader}}),_c('my-pagination',{attrs:{"childMsg":_vm.pageParams},on:{"callFather":_vm.callFather}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }